export default __webpack_public_path__ + "static/vladyslav-zubko-e241da0c7de7ccd589f8cb8738f84d16.png";